import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { api } from '../consts/url';
import { Observable } from 'rxjs';
import { UserSettingsModels } from '@share-models';

type UserSettings = UserSettingsModels.UserSettingsDocument;

@Injectable()
export class UserSettingsService {
  constructor(private http: HttpClient) {}

  public create(data: UserSettings): Observable<UserSettings> {
    return this.http.post<UserSettings>(api.userSettings.crud, data);
  }

  public me(lang: string): Observable<UserSettings> {
    const url = lang
      ? `${api.userSettings.me}?lang=${lang}`
      : api.userSettings.me;
    return this.http.get<UserSettings>(url);
  }

  public update(data: UserSettings): Observable<UserSettings> {
    return this.http.put<UserSettings>(api.userSettings.crud, data);
  }
}
